// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg fill=%27%23aaaaaa%27 width=%2720px%27 height=%2720px%27 viewBox=%270 0 256 256%27 id=%27Flat%27 xmlns=%27http://www.w3.org/2000/svg%27 stroke=%27%23aaaaaa%27%3E%3Cg stroke-width=%270%27%3E%3C/g%3E%3Cg stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3E%3C/g%3E%3Cg%3E%3Cpath d=%27M108,60.0001a16,16,0,1,1-16-16A16.00016,16.00016,0,0,1,108,60.0001Zm56,16a16,16,0,1,0-16-16A16.00016,16.00016,0,0,0,164,76.0001Zm-72,36a16,16,0,1,0,16,16A15.99985,15.99985,0,0,0,92,112.0001Zm72,0a16,16,0,1,0,16,16A15.99985,15.99985,0,0,0,164,112.0001Zm-72,68a16,16,0,1,0,16,16A15.99985,15.99985,0,0,0,92,180.0001Zm72,0a16,16,0,1,0,16,16A15.99985,15.99985,0,0,0,164,180.0001Z%27%3E%3C/path%3E%3C/g%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --txtcolor: #121212;
    --bgcolor: #f4f4f4;
    --bgcellcolor: white;
    --btncolor: white;
    --btnactive: #121212;
    --btnsavebordercolor: #4caf50;
    --btnsavehovercolor: #206123;
    --btncxlbordercolor: #c3912d;
    --btncxlhovercolor: #845f14;
    --btndelbordercolor: #e31a36;
    --btndelhovercolor: #8a0b1d;
    --unscheduled: #cbead0;
    --timeoff: #05064680;
    --borderradius: 8px;
    --fontsize: 0.75rem;
    --fontfam: Verdana, Geneva, Tahoma, sans-serif;
    --gridcols: repeat(7, 1fr);
}

[data-theme="dark"] {
    --bgcolor: #121212;
    --bgcellcolor: #121212;
    --txtcolor: white;
    --btncolor: white;
    --btnactive: #121212;
    --unscheduled: #121212;
    --timeoff: white;
}

body {
    margin: 0;
    color: var(--txtcolor);
    transition: background-color 0.3s ease, color 0.3s ease; 

}

.app-container {
    display: flex;
    flex-direction: row;
    font-family: var(--fontfam);
    font-size: var(--fontsize);
    letter-spacing: -0.02rem;
}

.content {
    display: flex;
    flex-direction: column;
    flex: 1 1 100%;
    min-height: 100vh;
    padding-top: 1.5rem;
    background: var(--bgcolor);

}

.form-group {
    display: grid;
    gap: 5px;
}

input {
    padding: 8px;
    border: 1px solid #ccc;
    border-radius: var(--borderradius);
    display: block;
    margin-top: 5px;
    width: 81%;
}

input:focus {
    outline: 1px solid var(--btnsavehovercolor);
}

.app-loading {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    opacity: 1;
}

.pizza {
    height: 100px;
    width: 100px;
    animation: spin 2s linear infinite;
    transform-origin: center;
}

.app-loading.fade-out {
  animation: fadeOutEffect 1.2s ease-out forwards;
}

@keyframes fadeOutEffect {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    visibility: hidden;
  }
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.day-container {
    display: flex;
    flex-direction: column;
}

.store-select {
    margin: 0 0 0.5rem 0;
}

.store-select:focus {
    outline: 1px solid var(--btnsavehovercolor);
}

.admin-tabs {
    display: flex;
    gap: 12px;
    padding-left: 1rem;
    border-bottom: 1px solid #ccc;
    margin-bottom: 16px;
    color: var(--btnactive);
}

.admin-tab {
    padding: 10px 20px;
    cursor: pointer;
    border: 1px solid #ccc;
    border-bottom: none;
    border-radius: var(--borderradius) var(--borderradius) 0 0;
    background: #f5f5f5;
    margin-bottom: -1px;
}

.admin-tab.active {
    background: #fff;
    border-bottom: 1px solid #fff;
}

.tab {
    margin-left: 1rem;
    width: 70%;
}

fieldset {
    border-radius: var(--borderradius);
    border: 1px solid #ccc;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
}

.store-checkboxes {
    padding: 1rem 0 0.5rem 1rem;
}

.admin-user-cb {
    width: 175px;
    margin-right: 1rem;
    margin-bottom: 0.25rem;
}

.store-add {
    width: 20%;
    margin-top: 2rem;
}

.store-add input {
    margin-bottom: 1rem;
}

.login-screen {
    font-family: var(--fontfam);
    width: 100vw;
    min-width: 100vw;
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

h2 {
    margin-left: 10px;
    display: inline;
}

h3 {
    margin: 0;
}

h5 {
    margin: 0 0 0.5rem 2rem;
    font-weight: 600;
    font-size: var(--fontsize);
}

.week-selection {
    margin: 0 0 1.5rem 1rem;
}

footer {
    height: 72px;
    background-color: var(--bgcolor);
    display: flex;
    justify-content: center;
    font-family: var(--fontfam);
    font-size: var(--fontsize);
    padding-top: 2rem;
}

.mern {
    width: 100px;
}

.footer-items {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 2rem;
}

.footer-item a {
    color: var(--btnsavehovercolor);
}

/* Sidebar.css */
.sidebar {
    width: 140px;
    background-color: var(--bgcolor);
    padding: 20px;
    display: flex;
    flex-direction: column;
}

.logo {
    width: 100%;
}

.sidebar h1 {
    display: inline;
    margin-right: 10px;
    font-size: 1.3rem;
}

.sidebar h2 {
    margin: 0;
    display: inline-block;
}

.sidebar ul {
    list-style: none;
    padding: 0;
    margin-top: 3rem;
    position: sticky;
    top: 2rem;
}

.sidebar ul li {
    margin: 20px 0;
    cursor: pointer;
    border: 1px solid var(--btnsavebordercolor);
    border-radius: var(--borderradius);
    padding: 10px;
}

.sidebar ul li:hover {
    color: white;
    background: var(--btnsavehovercolor);
}

.sidebar li.active {
    font-weight: bold;
    background: white;
    color: var(--btnactive);
}

.sidebar-user {
    border: none!important;
    padding: 0!important;
    margin-bottom: 1rem;
}

.sidebar-bottom {
    position: fixed;
    bottom: 0;
    left: 1rem;
    width: 127px;
}

.sidebar button {
    margin-top: auto;
    margin-bottom: 1rem;
}

.sidebar-user span {
    margin-left: 6px;
}

.sidebar-user:hover {
    background: unset!important;
    text-decoration: unset!important;
    color: unset!important;
}

.line-button {
    position: relative;
}

.wide {
    width: 99%;
}

.nolm {
    margin: 1rem 0!important;
}

.line-button::after {
    content: "";
    position: absolute;
    top: 50%;
    transform: translateX(-100%);
    left: 0%;
    height: 1px;
    width: 100vw;
    background-color: var(--btnsavebordercolor);
    transition: width 0.5s ease-in-out;
}

.line-button:hover::after {
    width: 0px;
}

.line {
    position: relative;
}

.line::after {
    content: "";
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: -6px;
    height: 1px;
    width: 5px;
    background-color: #ccc;
}

.groupselect {
    margin-top: 30px;
}

.groupselect select {
    height: 40px;
    margin-top: 3px;
    width: 100%;
}

.groupselect select:focus {
    outline: 1px solid var(--btnsavehovercolor);
}

select {
    height: 40px;
    border: 1px solid #ccc;
    border-radius: var(--borderradius);
    width: 90%;
    /*appearance: base-select; */
}

select:focus {
    outline: 1px solid var(--btnsavehovercolor);
}

#week {
    display: inline-block;
    width: 275px;
}

.day-container > div > select:last-child {
    margin-top: .5rem;
}

.employee-grid,
.staffing-grid {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.schedule {
    border: 1px solid #4caf5050;
    border-radius: 8px;
    padding: 1rem;
}

.grid-header,
.employee-item {
    display: grid;
    grid-template-columns: 20px 100px 50px 120px 90px repeat(8, 130px);
    gap: 5px;
    align-items: center;
}

.grid-header {
    font-weight: bold;
}

.user-heading {
    display: grid;
    grid-template-columns: repeat(6, 150px);
    gap: 5px;
    align-items: center;
    margin-bottom: 5px;
    font-weight: bold;
}

.employee-item {
    padding: 5px 0 5px 8px;
}

.employee-item:focus {
    outline: 1px solid var(--btnsavehovercolor);
}

.user-item,
.store-list {
    display: grid;
    grid-template-columns: repeat(7, 150px);
    gap: 5px;
    align-items: center;
}

.user-item div,
.stores-list div,
.employee-item div {
    background: var(--bgcellcolor);
}

.user-item div:last-of-type {
    background: unset;
}
.user-item:not(:nth-of-type(1)) {
    margin-top: 1rem;
}

.store-list {
    grid-template-columns: repeat(3, 150px);
    margin-top: 1rem;
}

.store-item:first-of-type {
    padding: 5px;
    border: 1px solid #ccc;
    border-radius: var(--borderradius);
}

.user-item div:not(:last-of-type) {
    padding: 5px;
    border: 1px solid #ccc;
    border-radius: var(--borderradius);
}

.stores-list {
    display: flex;
    flex-direction:row;
    flex-wrap: wrap;
    align-items: center;
}

.stores-item {
    display: flex;
    flex: 0 0 18%;
    justify-content: space-between;
    border: 1px solid #ccc;
    padding: 8px;
    margin: 1rem 1rem 0 0;
    border-radius: var(--borderradius);
    box-sizing: border-box;
}

.stores-item:hover {
    background:#18749320;
}

.stores-item div {
    display: flex;
    flex-direction: column;
    background: unset;
}

.stores-item div.btnwrap {
    flex-direction: row;
}

.stores-item div div:first-of-type {
    margin-bottom: 7px;
}

.stores-item.editing {
    flex-direction: column;
    align-items: stretch;
}

.stores-item.editing input {
    width: 100%;
    box-sizing: border-box;
}

.stores-item.editing input:last-of-type {
    margin-bottom: 10px;
}

/* -----------  buttons  ---------------- */
.btn-lg {
    background-color: white;
    color: black;
    padding: 10px 20px;
    font-size: 1rem;
    cursor: pointer;
    border: 1px solid var(--btnsavebordercolor);
    border-radius: var(--borderradius);
    margin: 1rem 1rem 1rem 1.5rem;
    min-width: 150px;
    width: 175px;
    text-align: center;
}

a.btn-lg {
    text-decoration: none;
}

.editbtn,
.updatebtn {
    background-color: white;
    color: black;
    border: 1px solid var(--btnsavebordercolor);
}

.editbtn:hover,
.updatebtn:hover {
    background-color: var(--btnsavehovercolor);
    border: 1px solid var(--btnsavehovercolor);
    color: white;
}

button {
    margin: 0 4px;
    background-color: white;
    color: black;
    border: 1px solid var(--btndelbordercolor);
    border-radius: var(--borderradius);
    padding: 7px 9px;
    cursor: pointer;
}

button:hover {
    background-color: var(--btndelhovercolor);
    border: 1px solid var(--btndelhovercolor);
    color: white;
}

button:focus {
    outline: 1px solid var(--btnsavehovercolor);
}

.btn-lg:hover,
.shift-edit button.savebtn:hover,
button.savebtn:hover {
    background-color: var(--btnsavehovercolor);
    border: 1px solid var(--btnsavehovercolor);
    color: white;
}

.shift-edit button {
    flex: 1;
    min-width: 0;
    font-size: var(--fontsize);
    margin: 5px 0 3px 0;
}

.shift-edit button.savebtn,
button.savebtn {
    background-color: white;
    border: 1px solid var(--btnsavebordercolor);
    color: black
}

button.savebtn:disabled {
    background-color: var(--bgcolor);
    color: #121212;
    cursor: not-allowed;
    opacity: 0.6;
}

.shift-edit button.cxlbtn,
button.cxlbtn {
    background-color: white;
    border: 1px solid var(--btncxlbordercolor);
    color: black
}

.shift-edit button.cxlbtn:hover,
button.cxlbtn:hover {
    background-color: var(--btncxlhovercolor);
    border: 1px solid var(--btncxlhovercolor);
    color: white;
}

.time-off {
    color: var(--timeoff);
    font-style: italic;
    font-weight: 700;
}

.employee-item::before,
.drag-handle {
    content: '';
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    height: 25px;
    width: 20px;
    display: inline-block;
    background-repeat: no-repeat;
    background-position: center;
    cursor: grab;
}

.employee-item div {
    padding: 5px;
    border: 1px solid #ccc;
    border-radius: var(--borderradius);
    color: var(--txtcolor);
}

.employee-item div:nth-of-type(12) {
    border: none;
    background: var(--bgcolor);
}

.employee-item div > div {
    border: none;
    padding: 0;
}

/* Modal overlay */
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 999;
}

/* Modal content */
.modal {
    background: var(--bgcolor);
    border: 1px solid var(--txtcolor);
    padding: 20px;
    border-radius: var(--borderradius);
    width: 85vw;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.modal.sm {
    width: 500px;
}

.day-container h4 {
    margin: 7px 0;
}

label {
    margin-top: .5rem;
    font-weight: bold;
}



/* ── Form sections modal ───────────────────── */

.form-section-basic {
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;
    padding-bottom: 1rem;
    margin-bottom: 1rem;
    align-items: flex-end;
}

.form-section-basic label {
    display: flex;
    flex-direction: column;
    font-weight: bold;
    font-size: var(--fontsize);
    min-width: 110px;
    flex: 1;
}

.form-section-basic input[type="text"],
.form-section-basic input[type="tel"] {
    margin-top: 6px;
    height: 40px;
    width: 100%;
    padding: 0.5rem;
    box-sizing: border-box;
    border: 1px solid #ccc;
    border-radius: var(--borderradius);
    font-family: var(--fontfam);
    font-size: var(--fontsize);
}

.form-section-basic input[type="text"]:focus,
.form-section-basic input[type="tel"]:focus {
    outline: 1px solid var(--btnsavehovercolor);
}

.form-section-basic select {
    margin-top: 6px;
    height: 40px;
    width: 100%;
    border: 1px solid #ccc;
    border-radius: var(--borderradius);
    font-family: var(--fontfam);
    font-size: var(--fontsize);
}

.form-section-basic select:focus {
    outline: 1px solid var(--btnsavehovercolor);
}

.form-section-availability {
    display: grid;
    grid-template-columns: repeat(7, 30px 1fr) 30px;
    gap: 0.75rem;
    padding-bottom: 1rem;
    margin-bottom: 1rem;
}

.copy-arrows {
    margin: 1.6rem 0 0 -0.25rem;
}
.copy-next {
    align-self: center;
    padding: 4px 4px 6px 4px;
    margin: 0.5rem 0 0 0;
}

.copy-all {
    margin: 1rem 1rem 0 0;
}

.form-section-availability .day-container h4 {
    margin: 0 0 6px 0;
    font-size: 0.7rem;
    font-weight: bold;
}

.form-section-actions {
    display: flex;
    justify-content: flex-end;
    gap: 0.75rem;
    margin-top: 0.5rem;
}

.form-section-actions button {
    padding: 10px 20px;
}

/* ── PositionSelector ─────────────────────────────────────── */

/* Self-contained unit inside the basic row — never grows or shrinks */
.position-selector {
    flex: 0 0 auto;
    align-self: flex-end;
    padding-bottom: 8px;
}

.position-selector-label {
    display: block;
    font-weight: bold;
    font-size: var(--fontsize);
    margin-bottom: 6px;
}

/* All four positions in a horizontal row */
.position-rows {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    gap: 0.75rem;
    flex-wrap: nowrap;
}

/* Each position item has a fixed width so nothing shifts when Exp appears */
.position-item {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 90px;
    flex-shrink: 0;
}

.position-checkbox-label {
    display: flex;
    flex-direction: row !important;
    align-items: center;
    gap: 0.35rem;
    font-weight: normal;
    font-size: var(--fontsize);
    white-space: nowrap;
    cursor: pointer;
    margin-top: 0;
    width: 100%;
    justify-content: flex-start;
}

.position-checkbox-label input[type="checkbox"] {
    width: 14px;
    height: 14px;
    margin: 0;
    cursor: pointer;
}

/* Fixed-height slot for Exp — always reserves space so nothing shifts */
.position-exp-slot {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: 0.3rem;
    height: 28px;
    margin-top: 4px;
    width: 100%;
}

.position-exp-label {
    font-weight: bold;
    font-size: var(--fontsize);
    white-space: nowrap;
}

.position-exp-slot select {
    height: 28px;
    width: 50px;
    padding: 0 4px;
    border: 1px solid #ccc;
    border-radius: var(--borderradius);
    font-family: var(--fontfam);
    font-size: var(--fontsize);
    margin-top: 0;
}

.position-exp-slot select:focus {
    outline: 1px solid var(--btnsavehovercolor);
}

.position-warning {
    display: block;
    margin-top: 0.4rem;
    color: var(--btndelbordercolor);
    font-size: 0.65rem;
    font-weight: normal;
}

/* ── Can Exceed 30hrs checkbox ────────────────────────────── */

.checkbox-label {
    display: flex;
    flex-direction: row !important;
    align-items: center;
    gap: 0.4rem;
    font-weight: bold;
    font-size: var(--fontsize);
    margin-top: 0;
    cursor: pointer;
    min-width: unset;
    flex: unset !important;
    white-space: nowrap;
    align-self: flex-end;
    padding-bottom: 8px;
}

.checkbox-label input[type="checkbox"] {
    width: 14px;
    height: 14px;
    margin: 0;
    color: white;
    accent-color: var(--btnsavehovercolor);
    cursor: pointer;
}

/* ── Field error messages ─────────────────────────────────── */

.field-error {
    color: var(--btndelbordercolor);
    font-size: 0.6rem;
    font-weight: normal;
    margin-top: 2px;
}

.scheduling-requirements {
    margin: 1rem;
}

.sales-data-grid {
    display: grid;
    grid-template-columns: var(--gridcols);
    margin: 1rem;
}

.sales-row {
    display: grid;
    gap: 10px;
    margin-bottom: 1rem;
}

.smaller {
    font-size: 0.65rem;
}

.warnings-section {
    margin: 2rem 0 2rem 10px;
}

.schedule-grid {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.schedule-header,
.schedule-item,
.schedule-summary {
    display: grid;
    gap: 5px;
    align-items: center;
}

.schedule-header {
    padding: 0 10px;
    font-weight: bold;
}

.schedule-item,
.schedule-summary {
    padding: 10px;
}

.schedule-item > div:not(:first-of-type) {
    border: 1px solid #ccc;
    border-radius: var(--borderradius);
    padding: 5px;
    background: var(--bgcellcolor);
}

.schedule-item > div > div,
.schedule-summary > div > div {
    border: none;
    padding: 2px;
}

.schedule-item:hover > div:not(:first-child),
.employee-item:hover > div:not(:last-child) {
    background-color: #add8e650;
}

.schedule-item > div:hover:not(.unscheduled):not(.drag-handle) {
    border: 1px solid #187493;
}

.schedule-item > div.unscheduled {
    border-color: var(--btnsavebordercolor);
    background: var(--unscheduled);
}

.schedule-item > div:has(.time-off) {
    background: var(--bgcellcolor);
}

.drop-target {
    outline: 2px dashed var(--btndelbordercolor);
    outline-offset: -2px;
}

.shift-draggable {
    cursor: grab;
}

.schedule-summary {
    font-weight: bold;
}

.grid-spacer {
    border: none !important;
    padding: 0 !important;
}

.shift-edit {
    display: flex;
    flex-wrap: wrap;
    gap: 3px;
}

.shift-edit select {
    flex: 1 1 45%;
    min-width: 0;
    height: 30px;
    padding: 2px;
    font-size: var(--fontsize);
}

.shift-edit > div {
    flex: 1 1 100%;
    display: flex;
    gap: 3px;
}

.generated-schedule {
    margin-bottom: 1.5rem;
}

.saved-schedules {
    margin: 1.5rem 0 1.5rem 1rem;
    width: 350px;
}

.summary-section {
    margin: 1rem 0 0 1rem;
}

.saved-schedules summary {
    cursor: pointer;
    padding: 4px 0;
    font-weight: bold;
}

.revision-list {
    list-style: none;
    margin: 0 0 0 1rem;
    padding: 0;
}

.revision {
    padding: 4px 8px;
    cursor: pointer;
    border-left: 3px solid transparent;
}

.revision:hover {
    background-color: var(--bgcolor);
}

.revision.selected {
    border-left-color: var(--btnsavehovercolor);
    font-weight: bold;
    background-color: #4caf5050;
}

.availability-hint {
    justify-content: center;
    font-size: 0.6rem;
    color: #333;
    margin-bottom: 2px;
}

.revision {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 1.5rem;
}

.revision-delete {
    padding: 2px 8px;
    min-width: 0;
    margin-left: auto;
    font-size: var(--fontsize);
    border-radius: var(--borderradius);
    visibility: hidden;
}

.revision:hover .revision-delete {
    visibility: visible;
}

.toast-stack {
    position: fixed;
    top: 24px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 6px;
    pointer-events: none;
    z-index: 2000;
}

.toast-anchored {
    color: var(--btnsavehovercolor);
    font-family: var(--fontfam);
    font-style: italic;
    letter-spacing: -.01rem;
    font-size: 0.6rem;
    position: fixed;
    transform: translate(-50%, -100%);
    animation: toast-rise-anchored 1.5s ease-out forwards;
    pointer-events: none;
    z-index: 2000;
    white-space: nowrap;
}

@keyframes toast-rise-anchored {
    0% {
        opacity: 0;
        transform: translate(-50%, -80%) scale(0.75);
    }

    15% {
        opacity: 1;
        transform: translate(-50%, -120%) scale(1);
    }

    60% {
        opacity: 1;
        transform: translate(-50%, -150%) scale(1.1);
    }

    100% {
        opacity: 0;
        transform: translate(-50%, -200%);
    }
}

.grid-header,
.schedule-header {
    position: sticky;
    top: 0;
    z-index: 100;
    background-color: var(--bgcolor);
    padding: 0.75rem 0 0.5rem 1rem;
    height: 2.25rem
}

.grid-header div,
.schedule-header div {
    margin-left: 10px;
}

.sort-menu {
    margin-left: 2rem;
}

.sort {
    color: var(--btnsavehovercolor);
    cursor: pointer;
    text-decoration: underline;
    width: fit-content;
    position: relative;
    margin: 0 0 0 2rem;
}

.sort::after {
    content: " ➔";
    opacity: 0;
    position: absolute;
    top: 1px;
    transition: all 0.2s ease-in-out;
}

@keyframes bounceRight {
    0% {
    transform: translateX(1px);
  }
  16.6% {
    transform: translateX(2px); 
  }
  33.3% {
    transform: translateX(4px);  
  }
  50% {
    transform: translateX(4px); 
  }
  66.6% {
    transform: translateX(3px);
  }
  83.3% {
    transform: translateX(2px);
  }
  100% {
    transform: translateX(1px); 
  }
}

.sort:hover::after {
    opacity: 1;
    animation: bounceRight 2s infinite linear;
}`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,oBAAoB;IACpB,iBAAiB;IACjB,oBAAoB;IACpB,6BAA6B;IAC7B,4BAA4B;IAC5B,4BAA4B;IAC5B,2BAA2B;IAC3B,4BAA4B;IAC5B,2BAA2B;IAC3B,sBAAsB;IACtB,oBAAoB;IACpB,mBAAmB;IACnB,mBAAmB;IACnB,8CAA8C;IAC9C,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,iBAAiB;IACjB,iBAAiB;IACjB,oBAAoB;IACpB,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,sBAAsB;IACtB,uDAAuD;;AAE3D;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,0BAA0B;IAC1B,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,cAAc;IACd,iBAAiB;IACjB,mBAAmB;IACnB,0BAA0B;;AAE9B;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,YAAY;IACZ,sBAAsB;IACtB,kCAAkC;IAClC,cAAc;IACd,eAAe;IACf,UAAU;AACd;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,UAAU;AACd;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,kCAAkC;IAClC,wBAAwB;AAC5B;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;IACV,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,aAAa;IACb,SAAS;IACT,kBAAkB;IAClB,6BAA6B;IAC7B,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,sBAAsB;IACtB,mBAAmB;IACnB,0DAA0D;IAC1D,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA;IACI,iBAAiB;IACjB,UAAU;AACd;;AAEA;IACI,kCAAkC;IAClC,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;IAC3B,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,uBAAuB;IACvB,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,gCAAgC;IAChC,aAAa;IACb,uBAAuB;IACvB,2BAA2B;IAC3B,0BAA0B;IAC1B,iBAAiB;AACrB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,+BAA+B;AACnC;;AAEA,gBAAgB;AAChB;IACI,YAAY;IACZ,gCAAgC;IAChC,aAAa;IACb,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,SAAS;IACT,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,gBAAgB;IAChB,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,cAAc;IACd,eAAe;IACf,2CAA2C;IAC3C,kCAAkC;IAClC,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,oCAAoC;AACxC;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA;IACI,sBAAsB;IACtB,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,SAAS;IACT,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;IAC3B,gCAAgC;IAChC,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,4BAA4B;IAC5B,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,2CAA2C;IAC3C,kCAAkC;AACtC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,2BAA2B;IAC3B,UAAU;IACV,WAAW;IACX,UAAU;IACV,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,WAAW;AACf;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,YAAY;IACZ,sBAAsB;IACtB,kCAAkC;IAClC,UAAU;IACV,4BAA4B;AAChC;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;;IAEI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,2BAA2B;IAC3B,kBAAkB;IAClB,aAAa;AACjB;;AAEA;;IAEI,aAAa;IACb,kEAAkE;IAClE,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,uCAAuC;IACvC,QAAQ;IACR,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;;IAEI,aAAa;IACb,uCAAuC;IACvC,QAAQ;IACR,mBAAmB;AACvB;;AAEA;;;IAGI,8BAA8B;AAClC;;AAEA;IACI,iBAAiB;AACrB;AACA;IACI,gBAAgB;AACpB;;AAEA;IACI,uCAAuC;IACvC,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,sBAAsB;IACtB,kCAAkC;AACtC;;AAEA;IACI,YAAY;IACZ,sBAAsB;IACtB,kCAAkC;AACtC;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,aAAa;IACb,8BAA8B;IAC9B,sBAAsB;IACtB,YAAY;IACZ,qBAAqB;IACrB,kCAAkC;IAClC,sBAAsB;AAC1B;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;AACvB;;AAEA,2CAA2C;AAC3C;IACI,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,2CAA2C;IAC3C,kCAAkC;IAClC,6BAA6B;IAC7B,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;;IAEI,uBAAuB;IACvB,YAAY;IACZ,2CAA2C;AAC/C;;AAEA;;IAEI,0CAA0C;IAC1C,0CAA0C;IAC1C,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,YAAY;IACZ,0CAA0C;IAC1C,kCAAkC;IAClC,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,yCAAyC;IACzC,yCAAyC;IACzC,YAAY;AAChB;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;;;IAGI,0CAA0C;IAC1C,0CAA0C;IAC1C,YAAY;AAChB;;AAEA;IACI,OAAO;IACP,YAAY;IACZ,0BAA0B;IAC1B,mBAAmB;AACvB;;AAEA;;IAEI,uBAAuB;IACvB,2CAA2C;IAC3C;AACJ;;AAEA;IACI,gCAAgC;IAChC,cAAc;IACd,mBAAmB;IACnB,YAAY;AAChB;;AAEA;;IAEI,uBAAuB;IACvB,0CAA0C;IAC1C;AACJ;;AAEA;;IAEI,yCAAyC;IACzC,yCAAyC;IACzC,YAAY;AAChB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;;IAEI,WAAW;IACX,yDAA8rB;IAC9rB,YAAY;IACZ,WAAW;IACX,qBAAqB;IACrB,4BAA4B;IAC5B,2BAA2B;IAC3B,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,sBAAsB;IACtB,kCAAkC;IAClC,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,0BAA0B;AAC9B;;AAEA;IACI,YAAY;IACZ,UAAU;AACd;;AAEA,kBAAkB;AAClB;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,8BAA8B;IAC9B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;AAChB;;AAEA,kBAAkB;AAClB;IACI,0BAA0B;IAC1B,iCAAiC;IACjC,aAAa;IACb,kCAAkC;IAClC,WAAW;IACX,wCAAwC;AAC5C;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;AACrB;;;;AAIA,iDAAiD;;AAEjD;IACI,aAAa;IACb,eAAe;IACf,SAAS;IACT,oBAAoB;IACpB,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,iBAAiB;IACjB,0BAA0B;IAC1B,gBAAgB;IAChB,OAAO;AACX;;AAEA;;IAEI,eAAe;IACf,YAAY;IACZ,WAAW;IACX,eAAe;IACf,sBAAsB;IACtB,sBAAsB;IACtB,kCAAkC;IAClC,2BAA2B;IAC3B,0BAA0B;AAC9B;;AAEA;;IAEI,2CAA2C;AAC/C;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,WAAW;IACX,sBAAsB;IACtB,kCAAkC;IAClC,2BAA2B;IAC3B,0BAA0B;AAC9B;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,aAAa;IACb,+CAA+C;IAC/C,YAAY;IACZ,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;AAC/B;AACA;IACI,kBAAkB;IAClB,wBAAwB;IACxB,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA,gEAAgE;;AAEhE,sEAAsE;AACtE;IACI,cAAc;IACd,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,0BAA0B;IAC1B,kBAAkB;AACtB;;AAEA,2CAA2C;AAC3C;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,iBAAiB;AACrB;;AAEA,4EAA4E;AAC5E;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,YAAY;IACZ,mBAAmB;IACnB,0BAA0B;IAC1B,mBAAmB;IACnB,eAAe;IACf,aAAa;IACb,WAAW;IACX,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,SAAS;IACT,eAAe;AACnB;;AAEA,wEAAwE;AACxE;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,2BAA2B;IAC3B,WAAW;IACX,YAAY;IACZ,eAAe;IACf,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,0BAA0B;IAC1B,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,cAAc;IACd,sBAAsB;IACtB,kCAAkC;IAClC,2BAA2B;IAC3B,0BAA0B;IAC1B,aAAa;AACjB;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,+BAA+B;IAC/B,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA,gEAAgE;;AAEhE;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX,iBAAiB;IACjB,0BAA0B;IAC1B,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,mBAAmB;IACnB,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,SAAS;IACT,YAAY;IACZ,sCAAsC;IACtC,eAAe;AACnB;;AAEA,gEAAgE;;AAEhE;IACI,+BAA+B;IAC/B,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sCAAsC;IACtC,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;;;IAGI,aAAa;IACb,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;;IAEI,aAAa;AACjB;;AAEA;IACI,sBAAsB;IACtB,kCAAkC;IAClC,YAAY;IACZ,8BAA8B;AAClC;;AAEA;;IAEI,YAAY;IACZ,YAAY;AAChB;;AAEA;;IAEI,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,uCAAuC;IACvC,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,4CAA4C;IAC5C,oBAAoB;AACxB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,uBAAuB;IACvB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,0BAA0B;AAC9B;;AAEA;IACI,cAAc;IACd,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,4BAA4B;IAC5B,YAAY;AAChB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,kCAAkC;AACtC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,2CAA2C;IAC3C,iBAAiB;IACjB,2BAA2B;AAC/B;;AAEA;IACI,uBAAuB;IACvB,iBAAiB;IACjB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,0BAA0B;IAC1B,kCAAkC;IAClC,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,SAAS;IACT,SAAS;IACT,2BAA2B;IAC3B,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,QAAQ;IACR,oBAAoB;IACpB,aAAa;AACjB;;AAEA;IACI,+BAA+B;IAC/B,2BAA2B;IAC3B,kBAAkB;IAClB,uBAAuB;IACvB,iBAAiB;IACjB,eAAe;IACf,iCAAiC;IACjC,qDAAqD;IACrD,oBAAoB;IACpB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI;QACI,UAAU;QACV,4CAA4C;IAChD;;IAEA;QACI,UAAU;QACV,0CAA0C;IAC9C;;IAEA;QACI,UAAU;QACV,4CAA4C;IAChD;;IAEA;QACI,UAAU;QACV,iCAAiC;IACrC;AACJ;;AAEA;;IAEI,gBAAgB;IAChB,MAAM;IACN,YAAY;IACZ,gCAAgC;IAChC,8BAA8B;IAC9B;AACJ;;AAEA;;IAEI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,+BAA+B;IAC/B,eAAe;IACf,0BAA0B;IAC1B,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,UAAU;IACV,kBAAkB;IAClB,QAAQ;IACR,gCAAgC;AACpC;;AAEA;IACI;IACA,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;AACF;;AAEA;IACI,UAAU;IACV,yCAAyC;AAC7C","sourcesContent":[":root {\n    --txtcolor: #121212;\n    --bgcolor: #f4f4f4;\n    --bgcellcolor: white;\n    --btncolor: white;\n    --btnactive: #121212;\n    --btnsavebordercolor: #4caf50;\n    --btnsavehovercolor: #206123;\n    --btncxlbordercolor: #c3912d;\n    --btncxlhovercolor: #845f14;\n    --btndelbordercolor: #e31a36;\n    --btndelhovercolor: #8a0b1d;\n    --unscheduled: #cbead0;\n    --timeoff: #05064680;\n    --borderradius: 8px;\n    --fontsize: 0.75rem;\n    --fontfam: Verdana, Geneva, Tahoma, sans-serif;\n    --gridcols: repeat(7, 1fr);\n}\n\n[data-theme=\"dark\"] {\n    --bgcolor: #121212;\n    --bgcellcolor: #121212;\n    --txtcolor: white;\n    --btncolor: white;\n    --btnactive: #121212;\n    --unscheduled: #121212;\n    --timeoff: white;\n}\n\nbody {\n    margin: 0;\n    color: var(--txtcolor);\n    transition: background-color 0.3s ease, color 0.3s ease; \n\n}\n\n.app-container {\n    display: flex;\n    flex-direction: row;\n    font-family: var(--fontfam);\n    font-size: var(--fontsize);\n    letter-spacing: -0.02rem;\n}\n\n.content {\n    display: flex;\n    flex-direction: column;\n    flex: 1 1 100%;\n    min-height: 100vh;\n    padding-top: 1.5rem;\n    background: var(--bgcolor);\n\n}\n\n.form-group {\n    display: grid;\n    gap: 5px;\n}\n\ninput {\n    padding: 8px;\n    border: 1px solid #ccc;\n    border-radius: var(--borderradius);\n    display: block;\n    margin-top: 5px;\n    width: 81%;\n}\n\ninput:focus {\n    outline: 1px solid var(--btnsavehovercolor);\n}\n\n.app-loading {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 100vh;\n    opacity: 1;\n}\n\n.pizza {\n    height: 100px;\n    width: 100px;\n    animation: spin 2s linear infinite;\n    transform-origin: center;\n}\n\n.app-loading.fade-out {\n  animation: fadeOutEffect 1.2s ease-out forwards;\n}\n\n@keyframes fadeOutEffect {\n  from {\n    opacity: 1;\n  }\n  to {\n    opacity: 0;\n    visibility: hidden;\n  }\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.day-container {\n    display: flex;\n    flex-direction: column;\n}\n\n.store-select {\n    margin: 0 0 0.5rem 0;\n}\n\n.store-select:focus {\n    outline: 1px solid var(--btnsavehovercolor);\n}\n\n.admin-tabs {\n    display: flex;\n    gap: 12px;\n    padding-left: 1rem;\n    border-bottom: 1px solid #ccc;\n    margin-bottom: 16px;\n    color: var(--btnactive);\n}\n\n.admin-tab {\n    padding: 10px 20px;\n    cursor: pointer;\n    border: 1px solid #ccc;\n    border-bottom: none;\n    border-radius: var(--borderradius) var(--borderradius) 0 0;\n    background: #f5f5f5;\n    margin-bottom: -1px;\n}\n\n.admin-tab.active {\n    background: #fff;\n    border-bottom: 1px solid #fff;\n}\n\n.tab {\n    margin-left: 1rem;\n    width: 70%;\n}\n\nfieldset {\n    border-radius: var(--borderradius);\n    border: 1px solid #ccc;\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n}\n\n.store-checkboxes {\n    padding: 1rem 0 0.5rem 1rem;\n}\n\n.admin-user-cb {\n    width: 175px;\n    margin-right: 1rem;\n    margin-bottom: 0.25rem;\n}\n\n.store-add {\n    width: 20%;\n    margin-top: 2rem;\n}\n\n.store-add input {\n    margin-bottom: 1rem;\n}\n\n.login-screen {\n    font-family: var(--fontfam);\n    width: 100vw;\n    min-width: 100vw;\n    height: 100vh;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n}\n\nh2 {\n    margin-left: 10px;\n    display: inline;\n}\n\nh3 {\n    margin: 0;\n}\n\nh5 {\n    margin: 0 0 0.5rem 2rem;\n    font-weight: 600;\n    font-size: var(--fontsize);\n}\n\n.week-selection {\n    margin: 0 0 1.5rem 1rem;\n}\n\nfooter {\n    height: 72px;\n    background-color: var(--bgcolor);\n    display: flex;\n    justify-content: center;\n    font-family: var(--fontfam);\n    font-size: var(--fontsize);\n    padding-top: 2rem;\n}\n\n.mern {\n    width: 100px;\n}\n\n.footer-items {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap: 2rem;\n}\n\n.footer-item a {\n    color: var(--btnsavehovercolor);\n}\n\n/* Sidebar.css */\n.sidebar {\n    width: 140px;\n    background-color: var(--bgcolor);\n    padding: 20px;\n    display: flex;\n    flex-direction: column;\n}\n\n.logo {\n    width: 100%;\n}\n\n.sidebar h1 {\n    display: inline;\n    margin-right: 10px;\n    font-size: 1.3rem;\n}\n\n.sidebar h2 {\n    margin: 0;\n    display: inline-block;\n}\n\n.sidebar ul {\n    list-style: none;\n    padding: 0;\n    margin-top: 3rem;\n    position: sticky;\n    top: 2rem;\n}\n\n.sidebar ul li {\n    margin: 20px 0;\n    cursor: pointer;\n    border: 1px solid var(--btnsavebordercolor);\n    border-radius: var(--borderradius);\n    padding: 10px;\n}\n\n.sidebar ul li:hover {\n    color: white;\n    background: var(--btnsavehovercolor);\n}\n\n.sidebar li.active {\n    font-weight: bold;\n    background: white;\n    color: var(--btnactive);\n}\n\n.sidebar-user {\n    border: none!important;\n    padding: 0!important;\n    margin-bottom: 1rem;\n}\n\n.sidebar-bottom {\n    position: fixed;\n    bottom: 0;\n    left: 1rem;\n    width: 127px;\n}\n\n.sidebar button {\n    margin-top: auto;\n    margin-bottom: 1rem;\n}\n\n.sidebar-user span {\n    margin-left: 6px;\n}\n\n.sidebar-user:hover {\n    background: unset!important;\n    text-decoration: unset!important;\n    color: unset!important;\n}\n\n.line-button {\n    position: relative;\n}\n\n.wide {\n    width: 99%;\n}\n\n.nolm {\n    margin: 1rem 0!important;\n}\n\n.line-button::after {\n    content: \"\";\n    position: absolute;\n    top: 50%;\n    transform: translateX(-100%);\n    left: 0%;\n    height: 1px;\n    width: 100vw;\n    background-color: var(--btnsavebordercolor);\n    transition: width 0.5s ease-in-out;\n}\n\n.line-button:hover::after {\n    width: 0px;\n}\n\n.line {\n    position: relative;\n}\n\n.line::after {\n    content: \"\";\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    left: -6px;\n    height: 1px;\n    width: 5px;\n    background-color: #ccc;\n}\n\n.groupselect {\n    margin-top: 30px;\n}\n\n.groupselect select {\n    height: 40px;\n    margin-top: 3px;\n    width: 100%;\n}\n\n.groupselect select:focus {\n    outline: 1px solid var(--btnsavehovercolor);\n}\n\nselect {\n    height: 40px;\n    border: 1px solid #ccc;\n    border-radius: var(--borderradius);\n    width: 90%;\n    /*appearance: base-select; */\n}\n\nselect:focus {\n    outline: 1px solid var(--btnsavehovercolor);\n}\n\n#week {\n    display: inline-block;\n    width: 275px;\n}\n\n.day-container > div > select:last-child {\n    margin-top: .5rem;\n}\n\n.employee-grid,\n.staffing-grid {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n}\n\n.schedule {\n    border: 1px solid #4caf5050;\n    border-radius: 8px;\n    padding: 1rem;\n}\n\n.grid-header,\n.employee-item {\n    display: grid;\n    grid-template-columns: 20px 100px 50px 120px 90px repeat(8, 130px);\n    gap: 5px;\n    align-items: center;\n}\n\n.grid-header {\n    font-weight: bold;\n}\n\n.user-heading {\n    display: grid;\n    grid-template-columns: repeat(6, 150px);\n    gap: 5px;\n    align-items: center;\n    margin-bottom: 5px;\n    font-weight: bold;\n}\n\n.employee-item {\n    padding: 5px 0 5px 8px;\n}\n\n.employee-item:focus {\n    outline: 1px solid var(--btnsavehovercolor);\n}\n\n.user-item,\n.store-list {\n    display: grid;\n    grid-template-columns: repeat(7, 150px);\n    gap: 5px;\n    align-items: center;\n}\n\n.user-item div,\n.stores-list div,\n.employee-item div {\n    background: var(--bgcellcolor);\n}\n\n.user-item div:last-of-type {\n    background: unset;\n}\n.user-item:not(:nth-of-type(1)) {\n    margin-top: 1rem;\n}\n\n.store-list {\n    grid-template-columns: repeat(3, 150px);\n    margin-top: 1rem;\n}\n\n.store-item:first-of-type {\n    padding: 5px;\n    border: 1px solid #ccc;\n    border-radius: var(--borderradius);\n}\n\n.user-item div:not(:last-of-type) {\n    padding: 5px;\n    border: 1px solid #ccc;\n    border-radius: var(--borderradius);\n}\n\n.stores-list {\n    display: flex;\n    flex-direction:row;\n    flex-wrap: wrap;\n    align-items: center;\n}\n\n.stores-item {\n    display: flex;\n    flex: 0 0 18%;\n    justify-content: space-between;\n    border: 1px solid #ccc;\n    padding: 8px;\n    margin: 1rem 1rem 0 0;\n    border-radius: var(--borderradius);\n    box-sizing: border-box;\n}\n\n.stores-item:hover {\n    background:#18749320;\n}\n\n.stores-item div {\n    display: flex;\n    flex-direction: column;\n    background: unset;\n}\n\n.stores-item div.btnwrap {\n    flex-direction: row;\n}\n\n.stores-item div div:first-of-type {\n    margin-bottom: 7px;\n}\n\n.stores-item.editing {\n    flex-direction: column;\n    align-items: stretch;\n}\n\n.stores-item.editing input {\n    width: 100%;\n    box-sizing: border-box;\n}\n\n.stores-item.editing input:last-of-type {\n    margin-bottom: 10px;\n}\n\n/* -----------  buttons  ---------------- */\n.btn-lg {\n    background-color: white;\n    color: black;\n    padding: 10px 20px;\n    font-size: 1rem;\n    cursor: pointer;\n    border: 1px solid var(--btnsavebordercolor);\n    border-radius: var(--borderradius);\n    margin: 1rem 1rem 1rem 1.5rem;\n    min-width: 150px;\n    width: 175px;\n    text-align: center;\n}\n\na.btn-lg {\n    text-decoration: none;\n}\n\n.editbtn,\n.updatebtn {\n    background-color: white;\n    color: black;\n    border: 1px solid var(--btnsavebordercolor);\n}\n\n.editbtn:hover,\n.updatebtn:hover {\n    background-color: var(--btnsavehovercolor);\n    border: 1px solid var(--btnsavehovercolor);\n    color: white;\n}\n\nbutton {\n    margin: 0 4px;\n    background-color: white;\n    color: black;\n    border: 1px solid var(--btndelbordercolor);\n    border-radius: var(--borderradius);\n    padding: 7px 9px;\n    cursor: pointer;\n}\n\nbutton:hover {\n    background-color: var(--btndelhovercolor);\n    border: 1px solid var(--btndelhovercolor);\n    color: white;\n}\n\nbutton:focus {\n    outline: 1px solid var(--btnsavehovercolor);\n}\n\n.btn-lg:hover,\n.shift-edit button.savebtn:hover,\nbutton.savebtn:hover {\n    background-color: var(--btnsavehovercolor);\n    border: 1px solid var(--btnsavehovercolor);\n    color: white;\n}\n\n.shift-edit button {\n    flex: 1;\n    min-width: 0;\n    font-size: var(--fontsize);\n    margin: 5px 0 3px 0;\n}\n\n.shift-edit button.savebtn,\nbutton.savebtn {\n    background-color: white;\n    border: 1px solid var(--btnsavebordercolor);\n    color: black\n}\n\nbutton.savebtn:disabled {\n    background-color: var(--bgcolor);\n    color: #121212;\n    cursor: not-allowed;\n    opacity: 0.6;\n}\n\n.shift-edit button.cxlbtn,\nbutton.cxlbtn {\n    background-color: white;\n    border: 1px solid var(--btncxlbordercolor);\n    color: black\n}\n\n.shift-edit button.cxlbtn:hover,\nbutton.cxlbtn:hover {\n    background-color: var(--btncxlhovercolor);\n    border: 1px solid var(--btncxlhovercolor);\n    color: white;\n}\n\n.time-off {\n    color: var(--timeoff);\n    font-style: italic;\n    font-weight: 700;\n}\n\n.employee-item::before,\n.drag-handle {\n    content: '';\n    background-image: url(\"data:image/svg+xml,%3Csvg fill='%23aaaaaa' width='20px' height='20px' viewBox='0 0 256 256' id='Flat' xmlns='http://www.w3.org/2000/svg' stroke='%23aaaaaa'%3E%3Cg stroke-width='0'%3E%3C/g%3E%3Cg stroke-linecap='round' stroke-linejoin='round'%3E%3C/g%3E%3Cg%3E%3Cpath d='M108,60.0001a16,16,0,1,1-16-16A16.00016,16.00016,0,0,1,108,60.0001Zm56,16a16,16,0,1,0-16-16A16.00016,16.00016,0,0,0,164,76.0001Zm-72,36a16,16,0,1,0,16,16A15.99985,15.99985,0,0,0,92,112.0001Zm72,0a16,16,0,1,0,16,16A15.99985,15.99985,0,0,0,164,112.0001Zm-72,68a16,16,0,1,0,16,16A15.99985,15.99985,0,0,0,92,180.0001Zm72,0a16,16,0,1,0,16,16A15.99985,15.99985,0,0,0,164,180.0001Z'%3E%3C/path%3E%3C/g%3E%3C/svg%3E\");\n    height: 25px;\n    width: 20px;\n    display: inline-block;\n    background-repeat: no-repeat;\n    background-position: center;\n    cursor: grab;\n}\n\n.employee-item div {\n    padding: 5px;\n    border: 1px solid #ccc;\n    border-radius: var(--borderradius);\n    color: var(--txtcolor);\n}\n\n.employee-item div:nth-of-type(12) {\n    border: none;\n    background: var(--bgcolor);\n}\n\n.employee-item div > div {\n    border: none;\n    padding: 0;\n}\n\n/* Modal overlay */\n.modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(0, 0, 0, 0.5);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 999;\n}\n\n/* Modal content */\n.modal {\n    background: var(--bgcolor);\n    border: 1px solid var(--txtcolor);\n    padding: 20px;\n    border-radius: var(--borderradius);\n    width: 85vw;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.modal.sm {\n    width: 500px;\n}\n\n.day-container h4 {\n    margin: 7px 0;\n}\n\nlabel {\n    margin-top: .5rem;\n    font-weight: bold;\n}\n\n\n\n/* ── Form sections modal ───────────────────── */\n\n.form-section-basic {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 1rem;\n    padding-bottom: 1rem;\n    margin-bottom: 1rem;\n    align-items: flex-end;\n}\n\n.form-section-basic label {\n    display: flex;\n    flex-direction: column;\n    font-weight: bold;\n    font-size: var(--fontsize);\n    min-width: 110px;\n    flex: 1;\n}\n\n.form-section-basic input[type=\"text\"],\n.form-section-basic input[type=\"tel\"] {\n    margin-top: 6px;\n    height: 40px;\n    width: 100%;\n    padding: 0.5rem;\n    box-sizing: border-box;\n    border: 1px solid #ccc;\n    border-radius: var(--borderradius);\n    font-family: var(--fontfam);\n    font-size: var(--fontsize);\n}\n\n.form-section-basic input[type=\"text\"]:focus,\n.form-section-basic input[type=\"tel\"]:focus {\n    outline: 1px solid var(--btnsavehovercolor);\n}\n\n.form-section-basic select {\n    margin-top: 6px;\n    height: 40px;\n    width: 100%;\n    border: 1px solid #ccc;\n    border-radius: var(--borderradius);\n    font-family: var(--fontfam);\n    font-size: var(--fontsize);\n}\n\n.form-section-basic select:focus {\n    outline: 1px solid var(--btnsavehovercolor);\n}\n\n.form-section-availability {\n    display: grid;\n    grid-template-columns: repeat(7, 30px 1fr) 30px;\n    gap: 0.75rem;\n    padding-bottom: 1rem;\n    margin-bottom: 1rem;\n}\n\n.copy-arrows {\n    margin: 1.6rem 0 0 -0.25rem;\n}\n.copy-next {\n    align-self: center;\n    padding: 4px 4px 6px 4px;\n    margin: 0.5rem 0 0 0;\n}\n\n.copy-all {\n    margin: 1rem 1rem 0 0;\n}\n\n.form-section-availability .day-container h4 {\n    margin: 0 0 6px 0;\n    font-size: 0.7rem;\n    font-weight: bold;\n}\n\n.form-section-actions {\n    display: flex;\n    justify-content: flex-end;\n    gap: 0.75rem;\n    margin-top: 0.5rem;\n}\n\n.form-section-actions button {\n    padding: 10px 20px;\n}\n\n/* ── PositionSelector ─────────────────────────────────────── */\n\n/* Self-contained unit inside the basic row — never grows or shrinks */\n.position-selector {\n    flex: 0 0 auto;\n    align-self: flex-end;\n    padding-bottom: 8px;\n}\n\n.position-selector-label {\n    display: block;\n    font-weight: bold;\n    font-size: var(--fontsize);\n    margin-bottom: 6px;\n}\n\n/* All four positions in a horizontal row */\n.position-rows {\n    display: flex;\n    flex-direction: row;\n    align-items: flex-start;\n    gap: 0.75rem;\n    flex-wrap: nowrap;\n}\n\n/* Each position item has a fixed width so nothing shifts when Exp appears */\n.position-item {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    width: 90px;\n    flex-shrink: 0;\n}\n\n.position-checkbox-label {\n    display: flex;\n    flex-direction: row !important;\n    align-items: center;\n    gap: 0.35rem;\n    font-weight: normal;\n    font-size: var(--fontsize);\n    white-space: nowrap;\n    cursor: pointer;\n    margin-top: 0;\n    width: 100%;\n    justify-content: flex-start;\n}\n\n.position-checkbox-label input[type=\"checkbox\"] {\n    width: 14px;\n    height: 14px;\n    margin: 0;\n    cursor: pointer;\n}\n\n/* Fixed-height slot for Exp — always reserves space so nothing shifts */\n.position-exp-slot {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: flex-start;\n    gap: 0.3rem;\n    height: 28px;\n    margin-top: 4px;\n    width: 100%;\n}\n\n.position-exp-label {\n    font-weight: bold;\n    font-size: var(--fontsize);\n    white-space: nowrap;\n}\n\n.position-exp-slot select {\n    height: 28px;\n    width: 50px;\n    padding: 0 4px;\n    border: 1px solid #ccc;\n    border-radius: var(--borderradius);\n    font-family: var(--fontfam);\n    font-size: var(--fontsize);\n    margin-top: 0;\n}\n\n.position-exp-slot select:focus {\n    outline: 1px solid var(--btnsavehovercolor);\n}\n\n.position-warning {\n    display: block;\n    margin-top: 0.4rem;\n    color: var(--btndelbordercolor);\n    font-size: 0.65rem;\n    font-weight: normal;\n}\n\n/* ── Can Exceed 30hrs checkbox ────────────────────────────── */\n\n.checkbox-label {\n    display: flex;\n    flex-direction: row !important;\n    align-items: center;\n    gap: 0.4rem;\n    font-weight: bold;\n    font-size: var(--fontsize);\n    margin-top: 0;\n    cursor: pointer;\n    min-width: unset;\n    flex: unset !important;\n    white-space: nowrap;\n    align-self: flex-end;\n    padding-bottom: 8px;\n}\n\n.checkbox-label input[type=\"checkbox\"] {\n    width: 14px;\n    height: 14px;\n    margin: 0;\n    color: white;\n    accent-color: var(--btnsavehovercolor);\n    cursor: pointer;\n}\n\n/* ── Field error messages ─────────────────────────────────── */\n\n.field-error {\n    color: var(--btndelbordercolor);\n    font-size: 0.6rem;\n    font-weight: normal;\n    margin-top: 2px;\n}\n\n.scheduling-requirements {\n    margin: 1rem;\n}\n\n.sales-data-grid {\n    display: grid;\n    grid-template-columns: var(--gridcols);\n    margin: 1rem;\n}\n\n.sales-row {\n    display: grid;\n    gap: 10px;\n    margin-bottom: 1rem;\n}\n\n.smaller {\n    font-size: 0.65rem;\n}\n\n.warnings-section {\n    margin: 2rem 0 2rem 10px;\n}\n\n.schedule-grid {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n}\n\n.schedule-header,\n.schedule-item,\n.schedule-summary {\n    display: grid;\n    gap: 5px;\n    align-items: center;\n}\n\n.schedule-header {\n    padding: 0 10px;\n    font-weight: bold;\n}\n\n.schedule-item,\n.schedule-summary {\n    padding: 10px;\n}\n\n.schedule-item > div:not(:first-of-type) {\n    border: 1px solid #ccc;\n    border-radius: var(--borderradius);\n    padding: 5px;\n    background: var(--bgcellcolor);\n}\n\n.schedule-item > div > div,\n.schedule-summary > div > div {\n    border: none;\n    padding: 2px;\n}\n\n.schedule-item:hover > div:not(:first-child),\n.employee-item:hover > div:not(:last-child) {\n    background-color: #add8e650;\n}\n\n.schedule-item > div:hover:not(.unscheduled):not(.drag-handle) {\n    border: 1px solid #187493;\n}\n\n.schedule-item > div.unscheduled {\n    border-color: var(--btnsavebordercolor);\n    background: var(--unscheduled);\n}\n\n.schedule-item > div:has(.time-off) {\n    background: var(--bgcellcolor);\n}\n\n.drop-target {\n    outline: 2px dashed var(--btndelbordercolor);\n    outline-offset: -2px;\n}\n\n.shift-draggable {\n    cursor: grab;\n}\n\n.schedule-summary {\n    font-weight: bold;\n}\n\n.grid-spacer {\n    border: none !important;\n    padding: 0 !important;\n}\n\n.shift-edit {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 3px;\n}\n\n.shift-edit select {\n    flex: 1 1 45%;\n    min-width: 0;\n    height: 30px;\n    padding: 2px;\n    font-size: var(--fontsize);\n}\n\n.shift-edit > div {\n    flex: 1 1 100%;\n    display: flex;\n    gap: 3px;\n}\n\n.generated-schedule {\n    margin-bottom: 1.5rem;\n}\n\n.saved-schedules {\n    margin: 1.5rem 0 1.5rem 1rem;\n    width: 350px;\n}\n\n.summary-section {\n    margin: 1rem 0 0 1rem;\n}\n\n.saved-schedules summary {\n    cursor: pointer;\n    padding: 4px 0;\n    font-weight: bold;\n}\n\n.revision-list {\n    list-style: none;\n    margin: 0 0 0 1rem;\n    padding: 0;\n}\n\n.revision {\n    padding: 4px 8px;\n    cursor: pointer;\n    border-left: 3px solid transparent;\n}\n\n.revision:hover {\n    background-color: var(--bgcolor);\n}\n\n.revision.selected {\n    border-left-color: var(--btnsavehovercolor);\n    font-weight: bold;\n    background-color: #4caf5050;\n}\n\n.availability-hint {\n    justify-content: center;\n    font-size: 0.6rem;\n    color: #333;\n    margin-bottom: 2px;\n}\n\n.revision {\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    gap: 1.5rem;\n}\n\n.revision-delete {\n    padding: 2px 8px;\n    min-width: 0;\n    margin-left: auto;\n    font-size: var(--fontsize);\n    border-radius: var(--borderradius);\n    visibility: hidden;\n}\n\n.revision:hover .revision-delete {\n    visibility: visible;\n}\n\n.toast-stack {\n    position: fixed;\n    top: 24px;\n    left: 50%;\n    transform: translateX(-50%);\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 6px;\n    pointer-events: none;\n    z-index: 2000;\n}\n\n.toast-anchored {\n    color: var(--btnsavehovercolor);\n    font-family: var(--fontfam);\n    font-style: italic;\n    letter-spacing: -.01rem;\n    font-size: 0.6rem;\n    position: fixed;\n    transform: translate(-50%, -100%);\n    animation: toast-rise-anchored 1.5s ease-out forwards;\n    pointer-events: none;\n    z-index: 2000;\n    white-space: nowrap;\n}\n\n@keyframes toast-rise-anchored {\n    0% {\n        opacity: 0;\n        transform: translate(-50%, -80%) scale(0.75);\n    }\n\n    15% {\n        opacity: 1;\n        transform: translate(-50%, -120%) scale(1);\n    }\n\n    60% {\n        opacity: 1;\n        transform: translate(-50%, -150%) scale(1.1);\n    }\n\n    100% {\n        opacity: 0;\n        transform: translate(-50%, -200%);\n    }\n}\n\n.grid-header,\n.schedule-header {\n    position: sticky;\n    top: 0;\n    z-index: 100;\n    background-color: var(--bgcolor);\n    padding: 0.75rem 0 0.5rem 1rem;\n    height: 2.25rem\n}\n\n.grid-header div,\n.schedule-header div {\n    margin-left: 10px;\n}\n\n.sort-menu {\n    margin-left: 2rem;\n}\n\n.sort {\n    color: var(--btnsavehovercolor);\n    cursor: pointer;\n    text-decoration: underline;\n    width: fit-content;\n    position: relative;\n    margin: 0 0 0 2rem;\n}\n\n.sort::after {\n    content: \" ➔\";\n    opacity: 0;\n    position: absolute;\n    top: 1px;\n    transition: all 0.2s ease-in-out;\n}\n\n@keyframes bounceRight {\n    0% {\n    transform: translateX(1px);\n  }\n  16.6% {\n    transform: translateX(2px); \n  }\n  33.3% {\n    transform: translateX(4px);  \n  }\n  50% {\n    transform: translateX(4px); \n  }\n  66.6% {\n    transform: translateX(3px);\n  }\n  83.3% {\n    transform: translateX(2px);\n  }\n  100% {\n    transform: translateX(1px); \n  }\n}\n\n.sort:hover::after {\n    opacity: 1;\n    animation: bounceRight 2s infinite linear;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
